// Presentation protection shared by fresh responses and restored chat history.
export const sanitizeAssistantContent = value => String(value || '')
  .replace(/\[\s*(?:no citation markers(?: in (?:the )?answer)?|citations? (?:go|shown|displayed) separately)\s*\]/gi, '')
  .replace(/(?:\s*\[(?:citation\s*:\s*S\d{1,3}(?:\s*[,;]\s*S\d{1,3})*|S\d{1,3}|source[-_ ]?\d{1,3}|chunk[-_ ][a-z0-9_-]{1,64})\]\s*)+/gi, ' ')
  .replace(/(^|[\s(])(?:source|chunk)[-_]\d{1,4}(?=$|[\s).,;:!?])/gi, '$1')
  .replace(/[ \t]+([,.;:!?])/g, '$1')
  .replace(/[ \t]{2,}/g, ' ')
  .trim()

